module.exports = __webpack_public_path__ + "static/media/i_signin_light.ba5ad177.svg";